import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  textRight: {
    textAlign: 'right',
  },
  serviceList: {
    color: '#212B36',
    marginBottom: 8,
  },
  listLabel: {
    fontWeight: '500',
    color: '#637381',
    marginTop: '24px',
  },
  pointIcon: {
    cursor: 'pointer',
    color: '#637381',
    width: 16.67,
    height: 16.67,
  },
  titleMargin: {
    marginBottom: 10,
  },
  mainBox: {
    marginBottom: 24,
    '& h5': {
      fontWeight: 700,
    },
  },
  subtitle: {
    color: '#637381',
  },
  noteDetail: {
    marginTop: 24,
    borderRadius: 8,
    border: '1px solid rgba(145, 158, 171, 0.2)',
    padding: 15,
    '& p': {
      color: '#919EAB',
    },
  },
  boxMargin: {
    marginBottom: 24,
    marginLeft: 15,
  },
  iconMargin: {
    marginRight: 16,
    color: '#637381',
  },
  noteField: {
    width: '100%',
    marginBottom: 24,
    background: 'rgba(145, 158, 171, 0.08)',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
  },
  noteAddBtn: {
    float: 'right',
    borderRadius: 8,
    padding: '8px 12px',
    color: '#ffffff',
    fontWeight: 600,
    backgroundColor: '#212B36',
  },
  mainLabel: {
    color: '#000000',
    fontWeight: 600,
    marginBottom: 16,
  },
  notesLabel: {
    marginTop: '24px',
  },
}));

const UnifiedStatusNotes = (props) => {
    console.log(JSON.stringify(props));
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={0} className={classes.titleMargin}>
        <Grid item xs={10} sm={10} md={10}>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <Box mr={2} className={classes.mainBox}>
              <Typography variant="h5" gutterBottom>
                Appointment Cancelled
              </Typography>
              <Typography variant="body2" className={classes.subtitle}>
              {props.cancellation_reason}
              {props.cancellation_reason_details}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default UnifiedStatusNotes;
